import {
  setToken,
  setUserInfo,
  getToken,
  getUserInfo,
  getSavePwd,
  setSavePwd,
  delToken
} from '@/utils/user.js'
import Message from 'vue-m-message'

const state = {
  savePwd: getSavePwd() == 'true' || false,
  userInfo: getUserInfo(),
  token: getToken()
}

const getters = {
  getUserInfo: function(state){
    try{
      return JSON.parse(state.userInfo);
    }catch(e){
    }
    return state.userInfo;
  },
  getToken: state => state.token,
}

const mutations = {
  MU_SaveUserInfo(state, userInfo){
    state.userInfo = userInfo;
    state.token = userInfo.user_token;
    setUserInfo(state.userInfo);
    setToken(state.token);
    setSavePwd(state.savePwd);
  },

  MU_SavePwd(state, status){
    state.savePwd = status;
    setSavePwd(state.savePwd);
  },

  MU_Logout(state){
    delToken();
    //state.userInfo = null;
    state.token = null;

    Message({
      message: '登出成功',
      type: 'success',
      duration: 2 * 1000,
      position: 'center'
    })

    window.setTimeout(function(){
      window.location.reload();
    }, 2000)
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js